var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgOffSound = function SvgOffSound(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 3.449c0-1.39-1.882-1.98-2.77-.868l-3 3.76H3.309C2.033 6.341 1 7.312 1 8.511v2.891c0 1.198 1.033 2.17 2.308 2.17h1.918l2.995 3.835c.88 1.126 2.779.541 2.779-.856zm-4.538 3.76 3-3.76V16.55l-2.996-3.835c-.29-.372-.75-.59-1.24-.59H3.308c-.425 0-.77-.324-.77-.724V8.51c0-.4.345-.723.77-.723H5.23c.484 0 .94-.214 1.23-.578",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.598 7.24a.821.821 0 1 1 1.162 1.162L17.16 10l1.598 1.598a.82.82 0 1 1-1.16 1.161L16 11.161l-1.598 1.598a.821.821 0 1 1-1.161-1.16L14.839 10 13.24 8.402A.82.82 0 1 1 14.4 7.24L16 8.839z"
  })));
};
export default SvgOffSound;